// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zPse","newExpiryDate":"styles_newExpiryDate__2ieCm","footer":"styles_footer__3-V3Z"};